import React from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import {isEmpty} from '../../../../helpers/utils'
import Error from './Error'

const useStyles = makeStyles(questionStyles)

export default function Question ({question, context}) {

  const classes = useStyles()

  const {translate} = context
  const typeName = translate(question.typeName)
  const title = isEmpty(question.textpremise)
    ? typeName
    : `${typeName}: ${question.textpremise}`
  const section = context.quizQuestions[question.section] || []
  const questionIndex = section.findIndex(q => q.id == question.id)
  const questionTitle = `${questionIndex + 1}. ${title}`

  return (
    <Box className={classes.question}>
      <Box className={classes.questionTitle}>
        {questionTitle}
      </Box>
      <Box className={classes.errors}>
        {question.errors.map((error, index) => <Error key={index} {...{error, question, context}} />)}
      </Box>
    </Box>
  )
}

function questionStyles(theme) {

  return {
    questionTitle: {
      color: '#69738c',
      fontSize: '12pt'
    },
    errors: {
      display: 'flex',
      flexDirection: 'column',
      padding: 10
    }
  }
}
